import { render } from "./OptionsBar.vue?vue&type=template&id=33934606&scoped=true"
import script from "./OptionsBar.vue?vue&type=script&lang=js"
export * from "./OptionsBar.vue?vue&type=script&lang=js"

import "./OptionsBar.vue?vue&type=style&index=0&id=33934606&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33934606"]])

export default __exports__